module.exports = __webpack_public_path__ + "static/howItWork-3-a07fe9423e04d289807d3225addc6833.svg";